export class RecordIdInput {
    additionalThicknessId?: string;
    boltDimensionId?: string;
    boltMaterialId?: string;
    clampId?: string;
    clampMaterialId?: string;
    flangeFacingTypeId?: string;
    flangeMaterialId1?: string;
    flangeMaterialId2?: string;
    flangeTypeId1?: string;
    flangeTypeId2?: string;
    gasketId?: string;
    hubMaterialId?: string;
    lubricantId?: string;
    nutDimensionId?: string;
    pipeScheduleId?: string;
    pipeSizeId?: string;
    pressureClassId?: string;
    sealRingId?: string;
    sealRingMaterialId?: string;
    selectedToolId?: string;
    standardId?: string;
    manufacturerId?: string;
    flangeTypeId?: string;
    flangeMaterialId?: string;
    washerDimensionId?: string;
    
    boltMaterialAliasId?: string;
    flangeMaterialAliasId1?: string;
    flangeMaterialAliasId2?: string;
    gasketAliasId?: string;
}
